import { render, staticRenderFns } from "./SQuesTen.vue?vue&type=template&id=5e13006a&"
import script from "./SQuesTen.vue?vue&type=script&lang=js&"
export * from "./SQuesTen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports